/**
 * @flow
 * @relayHash 1fb07aa87e413d3a2d35ff29e4d931b5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedJournalEntriesContainer_journalEntries$ref = any;
export type JournalEntrySortField = "CREATED_AT" | "ENTRY_DATE" | "ENTRY_NUMBER" | "SOURCE_TYPE" | "STATUS" | "UPDATED_AT";
export type JournalEntryStatus = "DRAFT" | "POSTED" | "VOIDED";
export type JournalSourceType = "INVENTORY_ADJUSTMENT" | "INVOICE" | "JOB" | "MANUAL" | "PAYMENT" | "SHIPMENT";
export type SortDirection = "ASC" | "DESC";
export type JournalEntrySort = {|
  field: JournalEntrySortField,
  direction: SortDirection,
|};
export type PaginatedJournalEntriesContainerQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?JournalEntrySort,
  statuses?: ?$ReadOnlyArray<JournalEntryStatus>,
  sourceTypes?: ?$ReadOnlyArray<JournalSourceType>,
  startDate?: ?any,
  endDate?: ?any,
|};
export type PaginatedJournalEntriesContainerQueryResponse = {|
  +$fragmentRefs: PaginatedJournalEntriesContainer_journalEntries$ref
|};
export type PaginatedJournalEntriesContainerQuery = {|
  variables: PaginatedJournalEntriesContainerQueryVariables,
  response: PaginatedJournalEntriesContainerQueryResponse,
|};
*/


/*
query PaginatedJournalEntriesContainerQuery(
  $count: Int!
  $cursor: String
  $search: String
  $sortBy: JournalEntrySort
  $statuses: [JournalEntryStatus!]
  $sourceTypes: [JournalSourceType!]
  $startDate: Date
  $endDate: Date
) {
  ...PaginatedJournalEntriesContainer_journalEntries_3AGXhT
}

fragment PaginatedJournalEntriesContainer_journalEntries_3AGXhT on Query {
  journalEntries(first: $count, after: $cursor, search: $search, sortBy: $sortBy, statuses: $statuses, sourceTypes: $sourceTypes, startDate: $startDate, endDate: $endDate) {
    edges {
      cursor
      ...JournalEntriesTable_journalEntryEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment JournalEntriesTable_journalEntryEdges on JournalEntryEdge {
  node {
    id
    entryNumber
    entryDate
    memo
    sourceType
    status
    syncStatus
    postedAt
    voidedAt
    totalDebit
    totalCredit
    createdByUser {
      id
      firstName
      lastName
    }
    createdAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "JournalEntrySort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "statuses",
    "type": "[JournalEntryStatus!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceTypes",
    "type": "[JournalSourceType!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startDate",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "endDate",
    "type": "Date",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v2 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v3 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v4 = {
  "kind": "Variable",
  "name": "sourceTypes",
  "variableName": "sourceTypes"
},
v5 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v6 = {
  "kind": "Variable",
  "name": "statuses",
  "variableName": "statuses"
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PaginatedJournalEntriesContainerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "PaginatedJournalEntriesContainer_journalEntries",
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PaginatedJournalEntriesContainerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "journalEntries",
        "storageKey": null,
        "args": (v7/*: any*/),
        "concreteType": "JournalEntryConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "JournalEntryEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "JournalEntry",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "entryNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "entryDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "memo",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sourceType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "syncStatus",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "postedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "voidedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalDebit",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalCredit",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "createdByUser",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "journalEntries",
        "args": (v7/*: any*/),
        "handle": "connection",
        "key": "PaginatedJournalEntriesContainer_journalEntries",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PaginatedJournalEntriesContainerQuery",
    "id": null,
    "text": "query PaginatedJournalEntriesContainerQuery(\n  $count: Int!\n  $cursor: String\n  $search: String\n  $sortBy: JournalEntrySort\n  $statuses: [JournalEntryStatus!]\n  $sourceTypes: [JournalSourceType!]\n  $startDate: Date\n  $endDate: Date\n) {\n  ...PaginatedJournalEntriesContainer_journalEntries_3AGXhT\n}\n\nfragment PaginatedJournalEntriesContainer_journalEntries_3AGXhT on Query {\n  journalEntries(first: $count, after: $cursor, search: $search, sortBy: $sortBy, statuses: $statuses, sourceTypes: $sourceTypes, startDate: $startDate, endDate: $endDate) {\n    edges {\n      cursor\n      ...JournalEntriesTable_journalEntryEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JournalEntriesTable_journalEntryEdges on JournalEntryEdge {\n  node {\n    id\n    entryNumber\n    entryDate\n    memo\n    sourceType\n    status\n    syncStatus\n    postedAt\n    voidedAt\n    totalDebit\n    totalCredit\n    createdByUser {\n      id\n      firstName\n      lastName\n    }\n    createdAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '741122cf532f54548a9ef4aa8a402f78';
module.exports = node;
